/**
 * @license lucide-react v0.570.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createLucideIcon from '../createLucideIcon.js';

const __iconNode = [
  ["path", { d: "M13 2H6.5A2.5 2.5 0 0 0 4 4.5v15", key: "4azifu" }],
  ["path", { d: "M17 2v6", key: "qgmh37" }],
  ["path", { d: "M17 4h2", key: "13vrzo" }],
  ["path", { d: "M20 15.2V21a1 1 0 0 1-1 1H6.5a1 1 0 0 1 0-5H20", key: "192hzx" }],
  ["circle", { cx: "17", cy: "10", r: "2", key: "y0i25j" }]
];
const BookKey = createLucideIcon("book-key", __iconNode);

export { __iconNode, BookKey as default };
//# sourceMappingURL=book-key.js.map
